import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';

export const ScrollableContainer = styled(Column)`
  max-height: 600px;
  overflow: auto;
`;
